import { DefaultSla } from '@provision/service-level-utils';

/** Fixed trial length (1V-5895); the specialist never picks a length. */
export const TRIAL_MEMBERSHIP_LENGTH_DAYS = 60;

/** The only plans Basic Support may activate as a one-time trial. */
export const TRIAL_MEMBERSHIP_PLATFORM_SLA_IDS: string[] = [
  DefaultSla.EssentialsPlus,
  DefaultSla.Priority,
];
